import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LANDING_PATH } from '../App';
import { X } from 'lucide-react';

const PrivacyPolicy = () => {
    const navigate = useNavigate();
    const handleBack = () => {
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
        } else {
            navigate(LANDING_PATH, { replace: true });
        }
    };
    return (
        <div className="page-size p-4 md:p-8 relative">
            <button
                className="fixed top-4 right-4 btn btn-outline btn-square btn-sm"
                onClick={handleBack}
            >
                <X />
            </button>
            <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
            <div className="prose max-w-none">
                <p>Malaysia Fight League (MFL) is committed to protecting your personal data and respecting your privacy in accordance with the <b>Personal Data Protection Act 2010 (PDPA)</b> of Malaysia. This Privacy Policy outlines how we collect, use, disclose, and protect your information.</p>
                <h3>1. Information We Collect</h3>
                <p>We may collect the following types of information from you:</p>
                <ul>
                    <li><b>Personal Information</b>
                        <ul>
                            <li>Full name</li>
                            <li>Email address</li>
                            <li>Phone number</li>
                            <li>Date of birth</li>
                            <li>Identification details (for athlete registration)</li>
                            <li>Social media handles</li>
                            <li>Emergency contact information</li>
                        </ul>
                    </li>
                    <li><b>Payment Information</b>
                        <ul>
                            <li>Transaction details (amount, payment method)</li>
                            <li>Bank transfer slips (when applicable)</li>
                        </ul>
                        <i>Note: We do not store credit card or sensitive banking details.</i>
                    </li>
                    <li><b>Technical Information</b>
                        <ul>
                            <li>IP address</li>
                            <li>Browser type</li>
                            <li>Device information</li>
                            <li>Pages visited on our site</li>
                            <li>Cookies (see Section 6)</li>
                        </ul>
                    </li>
                </ul>
                <h3>2. How We Use Your Information</h3>
                <ul>
                    <li>Register athletes for MFL events</li>
                    <li>Match you with suitable opponents</li>
                    <li>Communicate important event updates</li>
                    <li>Provide support and respond to inquiries</li>
                    <li>Process and confirm PPV purchases</li>
                    <li>Share relevant media content (with consent)</li>
                    <li>Improve our website and marketing efforts</li>
                    <li>Comply with legal and regulatory obligations</li>
                </ul>
                <h3>3. Disclosure of Information</h3>
                <p>We do <b>not sell, rent, or trade</b> your personal data to any third party. However, your information may be shared with:</p>
                <ul>
                    <li>Our event partners and vendors (only when necessary for event operation)</li>
                    <li>Payment processors for transaction validation</li>
                    <li>Legal authorities when required by law</li>
                </ul>
                <h3>4. Media Usage</h3>
                <p>By participating in any MFL event, you consent to the use of your name, image, video, and voice in:</p>
                <ul>
                    <li>Event highlights and live streams</li>
                    <li>Promotional content and marketing material</li>
                    <li>Social media platforms and digital campaigns</li>
                </ul>
                <p>If you do not wish to be featured, you must inform us in writing <b>before</b> the event.</p>
                <h3>5. Data Protection & Security</h3>
                <p>We take reasonable and appropriate measures to:</p>
                <ul>
                    <li>Prevent unauthorized access or misuse</li>
                    <li>Protect against data breaches</li>
                    <li>Secure all digital and physical records</li>
                </ul>
                <p>Access to personal information is limited only to authorized personnel who are required to keep the information confidential.</p>
                <h3>6. Cookies & Tracking</h3>
                <p>Our website uses <b>cookies</b> to enhance user experience. Cookies help us understand:</p>
                <ul>
                    <li>How users interact with our website</li>
                    <li>What content is most popular</li>
                    <li>How to improve navigation and performance</li>
                </ul>
                <p>You can choose to disable cookies in your browser settings, but it may affect your browsing experience.</p>
                <h3>7. Your Rights</h3>
                <p>Under the PDPA, you have the right to:</p>
                <ul>
                    <li>Access your personal data</li>
                    <li>Request correction or updates</li>
                    <li>Withdraw your consent for data processing (which may affect your eligibility to participate in MFL events)</li>
                </ul>
                <p>To make such requests, contact us at:<br />
                    <b>info@malaysiafightleague.com</b></p>
                <h3>8. Retention of Data</h3>
                <p>We retain your personal data <b>only for as long as necessary</b> for the purposes outlined in this policy or as required by law.</p>
                <h3>9. Third-Party Links</h3>
                <p>Our website may contain links to external websites (e.g., payment gateways, sponsors). We are <b>not responsible</b> for the privacy practices of these third-party sites.</p>
                <h3>10. Updates to this Policy</h3>
                <p>We may update this Privacy Policy periodically. Changes will be posted on this page with a revised <b>"Last Updated"</b> date.<br />
                    <b>Last Updated:</b> 16 June 2025</p>
                <h3>11. Contact Us</h3>
                <p>If you have any questions or concerns about this Privacy Policy, please reach out to us:<br />
                    <b>info@malaysiafightleague.com</b><br />
                    <b>+60 10-983 1808</b><br />
                    <a href="http://www.malaysiafightleague.com" target="_blank" rel="noopener noreferrer">www.malaysiafightleague.com</a></p>
            </div>
        </div>
    );
};

export default PrivacyPolicy; 